<template lang="pug">
.row
  .col-12
    .text-center.mt-5
      img.img(
        src='/img/ilustrations/developer-documentation.svg'
        style='max-height: 260px'
      )
      p.m-auto.mt-4.mb-3(style='max-width: 420px') {{ $t('pages.developerDocumentation.description') }}
      a.btn.btn-primary(:href='docsUrl' target='_blank') {{ $t('pages.developerDocumentation.viewDocs') }}
</template>

<script>
import AppConfig from '@/config';

export default {
  created() {
    this.updatePageStrings();
  },
  methods: {
    updatePageStrings() {
      this.$store.dispatch(
        'page/setTitle',
        this.$t('pages.developerDocumentation.title')
      );
      this.$store.dispatch(
        'page/setHead',
        this.$t('pages.developerDocumentation.head')
      );
      this.$store.dispatch('page/setClass', 'account developer');
    },
  },
  computed: {
    docsUrl() {
      return AppConfig.docsUrl || '';
    },
  },
};
</script>

<style lang="stylus">
a
  text-decoration: none
</style>
